import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudSun03 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "cloud-sun03",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3.15 11A7.5348 7.5348 0 0 1 3 9.5C3 5.3579 6.3579 2 10.5 2c3.8031 0 6.945 2.8306 7.4339 6.5M6 22c-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 .1133 0 .2256.0047.3365.014C7.1562 11.6763 9.3824 10 12 10c2.2248 0 4.1668 1.2109 5.2029 3.0097A4.5685 4.5685 0 0 1 17.5 13c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 22 17.5 22H6Z"
    })
  }));
};
export default CloudSun03;